import { DashboardData, AgentDetail } from './types'
export const dashboardSeed: DashboardData = {
  financial: {
    receivablesUSD: 11400000,
    pipelineUSD: 56200000,
    usdtVolumeUSD: 240000,
    earlyPayCollectedUSD: 65000,
  },
  ops: {
    utilizationPct: 72,
    collectionsUSD: 4300000,
    turnoverDays: 11,
    efficiencyPct: 91,
  },
  agents: [
    {
      id: 'discovery',
      name: 'Discovery',
      ips: 854,
      processed: 1057000,
    },
    {
      id: 'extraction',
      name: 'Extraction',
      ips: 228,
      processed: 47481,
      confidence: 0.785,
      extras: { duplicatesResolved: 3200 },
    },
    {
      id: 'validation',
      name: 'Validation',
      ips: 191,
      processed: 40140,
      confidence: 0.893,
      extras: { buyerMatches: 31051, erpFails: 45 },
    },
    {
      id: 'underwriting',
      name: 'Underwriting',
      ips: 745,
      processed: 83840,
      confidence: 0.965,
      extras: { above085: 73200 },
    },
    {
      id: 'audit',
      name: 'On-Chain Audit',
      ips: 80,
      processed: 6842,
      extras: { verifications24h: 312 },
    },
  ],
}
export const agentDetails: Record<string, AgentDetail> = {
  discovery: {
    id: 'discovery',
    sources: ['QBO', 'NetSuite', 'SAP'],
    query: 'customer.creditLimit > 10000',
    indexed: 1059421,
  },
  extraction: {
    id: 'extraction',
    fieldParity: 0.785,
    duplicatesResolved: 3200,
    schemaVersion: 'v1.8',
  },
  validation: {
    id: 'validation',
    evidence: {
      erp: true,
      buyer: true,
      ship: true,
      bank: false,
      hash: true,
    },
    buyerMismatch: 89,
    erpFail: 45,
  },
  underwriting: {
    id: 'underwriting',
    scoreFormula:
      '0.39*extract + 0.25*buyer + 0.15*hist + 0.10*ship + 0.10*fingerprint',
    threshold: 0.85,
    above085: 73200,
  },
  audit: {
    id: 'audit',
    verifications24h: 312,
    fingerprint: 'SHA256: 16d7e3…',
    explorerUrl:
      'https://sepolia.etherscan.io/tx/0x88df016429689c079f3b2f6ad39fa052532c56795b733da78a91ebe6a713944b',
  },
}
